import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const DemandeDevisPage = lazy(() => import('../pages/demande-devis/page'));
const OffresPage = lazy(() => import('../pages/offres/page'));
const PaiementPage = lazy(() => import('../pages/paiement/page'));
const PaiementSuccessPage = lazy(() => import('../pages/paiement/success'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/demande-devis',
    element: <DemandeDevisPage />,
  },
  {
    path: '/offres',
    element: <OffresPage />,
  },
  {
    path: '/paiement',
    element: <PaiementPage />,
  },
  {
    path: '/paiement/success',
    element: <PaiementSuccessPage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
